<div class="grid">
    <div class="col-12 mb-4">
        <mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col">
            <mat-card-title class="flex justify-content-between mt-1">
                <div class="text-xl font-bold">{{ 'txProjectOffice.assignments' | translate }}</div>
                <div class="buttons">
                    <button mat-stroked-button routerLink="0" color="primary" class="mr-1 tx-add-assignement-button">
                        <fa-icon icon="plus"></fa-icon>
                        {{ 'txProjectOffice.newAssignment' | translate }}
                    </button>
                    <button class="tx-settings-button" mat-icon-button (click)="onOpenWorkstepsDialog()">
                        <fa-icon icon="cog" class="large-icon"></fa-icon>
                    </button>
                </div>
            </mat-card-title>
            <mat-card-content>
                <div class="display-flex">
                    <mat-form-field class="flex-grow-1 mr-1" appearance="outline">
                        <mat-label>{{ 'txProjectOffice.search' | translate }}</mat-label>
                        <input #searchInput matInput [value]="SearchQuery" (keyup)="onSearch(searchInput.value)"/>
                        <button *ngIf="SearchQuery" matSuffix mat-icon-button
                                (click)="SearchQuery = ''; onSearch(SearchQuery)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'txProjectOffice.status_filter' | translate }}</mat-label>
                        <mat-select [value]="StatusFilter" (valueChange)="onFilterList($event)">
                            <mat-option *ngFor="let state of ProjectStates" [value]="state.value">
                                {{ state.description }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap">
                    <div class="table-scroll" style="--tscroll-min: 820px">
                    <mat-table matSort class="projects-table border-1 rounded min-w-[800px]"
                               [dataSource]="ProjectsDataSource" (matSortChange)="onSort($event)">
                        <ng-container matColumnDef="project_number">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base">{{ 'txProjectOffice.number' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <a [routerLink]="row.project_id">
                                    {{ row.project_number }}
                                </a>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="project_name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base">{{ 'txProjectOffice.description_alt' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">{{ row.project_name }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="creation_date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base">{{ 'txProjectOffice.start' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">{{ row.creation_date | date: 'dd.MM.yyyy' }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="project_state">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base">{{ 'txProjectOffice.status' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">{{ getProjectState(row.project_state) }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="target_date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base">{{ 'txProjectOffice.end_planed' | translate }}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">{{ row.target_date | date: 'dd.MM.yyyy' }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="target_time">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base flex-justify-content-flex-end"
                            >{{ 'txProjectOffice.should_time' | translate }}
                            </mat-header-cell
                            >
                            <mat-cell class="flex-justify-content-flex-end"
                                      *matCellDef="let row">{{ row.target_time }}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="calculated_time">
                            <mat-header-cell *matHeaderCellDef mat-sort-header
                                             class="font-weight-bold text-base flex-justify-content-flex-end"
                            >{{ 'txProjectOffice.is_time' | translate }}
                            </mat-header-cell
                            >
                            <mat-cell class="flex-justify-content-flex-end"
                                      *matCellDef="let row">{{ row.calculated_time }}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <div>
                                    <button mat-icon-button [matMenuTriggerFor]="menu">
                                        <fa-icon icon="ellipsis-v"></fa-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <div
                                                mat-menu-item
                                                class="no-margin"
                                                [matTooltipDisabled]="row.calculated_time === '00:00'"
                                                matTooltip="{{ 'txProjectOffice.assignment_has_booked_time' | translate }}">
                                            <button
                                                    mat-icon-button
                                                    type="button"
                                                    (click)="deleteProject(row.project_id)"
                                                    [disabled]="row.calculated_time !== '00:00'">
                                                <fa-icon icon="minus-circle"></fa-icon>
                                                <span class="text-danger"> {{ 'general.delete' | translate }}</span>
                                            </button>
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <div class="flex justify-content-center" *matNoDataRow>
						<span class="p-2">
							<mat-spinner [diameter]="50"></mat-spinner>
						</span>
                        </div>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                    </div>
                    <mat-paginator #projectsPaginator [pageSizeOptions]="[5, 15, 25, 50, 100]" [pageSize]="15" showFirstLastButtons></mat-paginator>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
